/**
 * Expands products by their first variant option (Variant 1, e.g., Color).
 * Each unique value in variant_options[0] becomes a separate product listing card
 * with its variant-specific image.
 *
 * Expanded items have these extra fields:
 *   _variantExpanded: true
 *   _variantKey:  "Color"          (the option name)
 *   _variantValue: "Black"         (the specific value)
 *   _baseId:      original product id
 *   _baseSlug:    original url_slug
 *   id:           "{original_id}__{variantValue}"  (unique React key)
 *   main_image:   variant-specific image (overrides original)
 */
export function expandByVariant1(products) {
  const result = [];
  for (const product of products) {
    const opts = product.variant_options || [];
    const v1 = opts[0]; // first variant option

    if (!v1?.values?.length) {
      result.push(product);
      continue;
    }

    const keyLower = v1.name.toLowerCase(); // "color", "size", etc.
    const combos = product.variant_combinations || [];

    // Map: variant value → first combo image for that value
    const imageMap = {};
    for (const combo of combos) {
      const val = combo[keyLower];
      if (val && !imageMap[val]) {
        imageMap[val] = combo.image || null;
      }
    }

    for (const val of v1.values) {
      result.push({
        ...product,
        main_image: imageMap[val] || product.main_image,
        id: `${product.id}__${val}`,
        _baseId: product.id,
        _baseSlug: product.url_slug || product.id,
        _variantExpanded: true,
        _variantKey: v1.name,
        _variantValue: val,
      });
    }
  }
  return result;
}
